<template>
  <v-dialog :value="value" max-width="90vw" @input="$emit('input', $event)">
    <v-tabs v-model="model" fixed-tabs>
      <v-tab v-for="(tab, index) in tabs" :key="'Tab ' + index" active-class="active-class">{{
        tab
      }}</v-tab>
      <v-tabs-slider class="custom-text"></v-tabs-slider>
      <v-tabs-items v-model="model">
        <v-tab-item v-for="(tab, index) in tabs" :key="'Item ' + index">
          <component
            :is="components[tab]"
            @teacher-updated="$emit('teacher-updated', $event)"
          ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-dialog>
</template>
<script>
import Bio from "./Bio";
import Summary from "./Summary";
import TeacherStudents from "./TeacherStudents";

export default {
  props: {
    value: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      tabs: ["Students", "Summary", "Bio"],
      model: 0,
      components: {
        Students: TeacherStudents,
        Summary: Summary,
        Bio: Bio,
      },
    };
  },
};
</script>
<style scoped>
.active-class {
  color: #29284c !important;
}
</style>
